import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"

import General from "../../../utils/General";
import AuthManager from "../../../utils/AuthManager";

import TerminalOrderLineItemsTable from "./TerminalOrderLineItemsTable";

import ViewCell from "./cells/ViewCell";

export default class TerminalOrdersTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      live: props.live,
      company: props.company,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
    }, () => this.table.current.refresh())
  }


  _getColumns() {
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: terminalOrder => moment(terminalOrder.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Partner',
        id: 'store.company.name',
        accessor:  terminalOrder => terminalOrder.association_processor?.association.name,
        Cell: (rowInfo) => {
          let terminalOrder = rowInfo.original

          return (
            <div className="d-flex align-items-center">
              <div className={"ml-2"}>
                <div className="text-dark-75 font-weight-bold line-height-sm">
                  {terminalOrder?.association_processor.association.name}
                </div>
              </div>
            </div>
          )
        }
      },
      {
        Header: 'Reference',
        id: 'reference',
        accessor:  terminalOrder => terminalOrder.reference
      },
      {
        Header: 'Status',
        id: 'external_status',
        accessor:  terminalOrder => General.snakeCaseToTitleCase(terminalOrder.external_status),
        Cell: (rowInfo) => {
          let terminalOrder = rowInfo.original

          let className = "label label-lg font-weight-bold label-inline w-110px ";
          let status = terminalOrder.external_status

          return (
            <span className={className}>
              {General.snakeCaseToTitleCase(status)}
            </span>
          );
        }
      },
      {
        Header: 'Region',
        id: 'region',
        accessor:  terminalOrder => terminalOrder.region.toUpperCase()
      },
      {
        Header: 'Actions',
        id: 'status',
        width: 150,
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let terminalOrder = rowInfo.original
          return (
            <span style={{overflow: 'visible', position: 'relative', width: 150}}>
              {terminalOrder.tracking_url && (
                <ViewCell
                  tooltip={'Track Order'}
                  onViewClicked={() => {
                    window.open(terminalOrder.tracking_url, '_blank')
                  }}
                />
              )}
            </span>
          )
        }
      }
    ]
  }

  _renderLineItems(terminalOrder){
    return (
      <TerminalOrderLineItemsTable
        terminalOrder={terminalOrder}
      />
    )
  }

  render() {
    let {
      company,
    } = this.state

    const columns = this._getColumns()

    if(AuthManager.isAuthenticated()){
      columns.splice(1, 1)
    }

    let endpoint = `${window.Api.TerminalOrders}?company_id=${company?.id || ""}`

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${endpoint}`}
          noDataMessage={"No Terminal Orders Found"}
          title={"Terminal Orders"}
          columns={columns}
          showExport={false}
          showHeader={true}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          SubComponent={row => this._renderLineItems(row.original)}
        />
      </div>
    )
  }
}

TerminalOrdersTable.defaultProps = {
  latestResults: false
}
